import { MarketplaceCnameLookupFragment_categories } from '@src/hooks/useMarketplace/queries/__generated__/MarketplaceCnameLookupFragment'
import { DateifyOutlet } from '@src/utils/fulfilmentTimes/parsers'

import { Outlet } from '../graphql-types'

export const sortOutletsByMostCategories = <
  T extends DateifyOutlet<Pick<Outlet, 'outletCuisines'>>
>(
  outlets: T[],
  selectedCategories: MarketplaceCnameLookupFragment_categories[]
): T[] =>
  selectedCategories.length
    ? outlets.sort((a, b) => {
        // sort the outlets based on whichever ones have the most cuisine matches to the selected categories
        const cuisinesA = a.outletCuisines
          .map(({ name }: { name: string }) => name)
          .filter((cuisine: string) =>
            selectedCategories.some(({ name }) => name === cuisine)
          )
        const cuisinesB = b.outletCuisines
          .map(({ name }: { name: string }) => name)
          .filter((cuisine: string) =>
            selectedCategories.some(({ name }) => name === cuisine)
          )

        return cuisinesB.length - cuisinesA.length
      })
    : outlets
